import { APPLE_TEAM_ID, BUNDLE_IDENTIFIER } from "./stores";

/**
 * HTTPS paths verified for Universal Links / App Links.
 * Intentionally empty: /app/* is public web content; in-app browsing must stay in the browser.
 * Opening the installed app is done via the custom URL scheme from AppDownloadButton on detail pages.
 */
export const UNIVERSAL_LINK_PATHS = [] as const;

/** Apple App ID for Universal Links (teamId.bundleId). */
export const APPLE_APP_ID = `${APPLE_TEAM_ID}.${BUNDLE_IDENTIFIER}`;

export interface AppleAppSiteAssociation {
  applinks: {
    apps: [];
    details: { appID: string; paths: string[] }[];
  };
  webcredentials: { apps: string[] };
}

export interface AssetLinkEntry {
  relation: string[];
  target: {
    namespace: string;
    package_name: string;
    sha256_cert_fingerprints: string[];
  };
}

export const getAppleAppSiteAssociation = (): AppleAppSiteAssociation => ({
  applinks: {
    apps: [],
    details: [],
  },
  webcredentials: { apps: [APPLE_APP_ID] },
});

/** Empty: no https App Links; web /app/* stays in the browser (see UNIVERSAL_LINK_PATHS). */
export const getAssetLinks = (): AssetLinkEntry[] => [];
